import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { allResultsButton, backgroundResultsButton } from '../../../theme/default-theme';
import { ContentSpacing, breakpoint } from 'elc-base-theme';
import { Button } from 'elc-buttons';
import { translate, ITranslationsCollection } from 'elc-service';
import { IItemTypeahead } from '../../../internal/interfaces/ISearchInterfaces';
import {
    SEARCH_TYPE_PARAM,
    PREDICTIVE_SEARCH_PARAM,
    SEARCH_TEXT_PARAM
} from '../../constants/Search';

const SearchAllResultsButton = styled(Button)`
    width: 100%;
    height: ${ContentSpacing.space48};
    ${allResultsButton};
`;

const SearchAllResultsButtonWrapper = styled.div`
    padding: ${ContentSpacing.space8} ${ContentSpacing.space20};
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    ${backgroundResultsButton};
    [dir='rtl'] & {
        left: auto;
        right: 0;
    }

    ${breakpoint('desktop')`
        box-shadow: none;
        background: none;
        position: relative;
        width: auto;
        padding: 0;
        margin-top: auto;
        width:100%;
        left: auto;
    `};
`;

const SeeAllResultsLink = styled.a``;

export interface ISearchSuggestionButtonProps {
    inputValue: string;
    translations?: ITranslationsCollection;
    typeaheadResults: IItemTypeahead[];
    searchUrl?: string;
    searchParam: string;
}

@translate(['viewAllResultsLabel'])
@observer
export class SearchSuggestionButton extends React.Component<ISearchSuggestionButtonProps> {
    public render() {
        const resultsButtonSearchClassnames = classnames(
            'elc-results-search-button',
            'js-results-search-button'
        );

        const { searchUrl, searchParam, inputValue } = this.props;
        const { viewAllResultsLabel } = this.props.translations as ITranslationsCollection;

        return (
            <SearchAllResultsButtonWrapper className={resultsButtonSearchClassnames}>
                <SeeAllResultsLink
                    href={`${searchUrl}${searchParam}${inputValue}${SEARCH_TYPE_PARAM}${PREDICTIVE_SEARCH_PARAM}${SEARCH_TEXT_PARAM}`}
                    role="button"
                    aria-label={viewAllResultsLabel}
                    data-test-id="SEA-Search-Button-Overlay"
                    title={viewAllResultsLabel}
                >
                    <SearchAllResultsButton tabIndex={-1}>
                        {viewAllResultsLabel}
                    </SearchAllResultsButton>
                </SeeAllResultsLink>
            </SearchAllResultsButtonWrapper>
        );
    }
}
